import * as Sentry from '@sentry/react'

/**
 * Suivi des erreurs front avec Sentry.
 * Inactif tant que VITE_SENTRY_DSN n'est pas défini (dev local, previews sans DSN).
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) || import.meta.env.MODE,
    // Le portail affiche des données clients (mots de passe d'atelier, projets) :
    // ni corps HTTP, ni en-têtes, ni cookies, ni paramètres d'URL, ni variables locales
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false,
      stackFrameVariables: false,
    },
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  })
}

/** Rattache les erreurs à l'utilisateur connecté (identifiant et rôle seulement, pas d'email). */
export function setSentryUser(user: { id: string; role: string } | null) {
  if (!import.meta.env.VITE_SENTRY_DSN) return
  Sentry.setUser(user ? { id: user.id } : null)
  Sentry.setTag('role', user?.role ?? 'anonyme')
}

export { Sentry }
